<div class="setting-section">
  <app-operator-mngt-detail [customers]="customers" (operatorSaved)="onOperatorSaved($event)"></app-operator-mngt-detail>

  <div class="fc-mngt-toolbar">
    <h2 class="fc-mngt-title">Operators</h2>
    <div class="fc-mngt-search">
      <span class="material-icons fc-mngt-search-icon">search</span>
      <input class="fc-mngt-search-input" type="text" placeholder="Filter operators…" (keyup)="doFilter($any($event.target).value)" />
    </div>
  </div>

  <table mat-table [dataSource]="dataSource" class="operatorsTable" matSort>
    <ng-container matColumnDef="code">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Code</th>
      <td mat-cell *matCellDef="let element">{{ element.code }}</td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
      <td mat-cell *matCellDef="let element">{{ element.name }}</td>
    </ng-container>

    <ng-container matColumnDef="customer">
      <th mat-header-cell *matHeaderCellDef>Customer</th>
      <td mat-cell *matCellDef="let element">{{ element.customerName }}</td>
    </ng-container>

    <ng-container matColumnDef="Actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element" class="actionButtonCol">
        <button class="fc-action-btn" (click)="edit(element)">Edit</button>
        <button class="fc-action-btn fc-action-btn--danger" (click)="deleteConfirmDialog(element)">Delete</button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell fc-no-data" colspan="4">No operators found</td>
    </tr>
  </table>
</div>
